export default Array.isArray.bind(Array);
